module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "value-key": _vm.itemValue,
      "remote": _vm.remote,
      "remote-method": _vm.remoteMethod,
      "collapse-tags": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.setEvent('input', $event)
      },
      "input": function($event) {
        return _vm.setEvent('input', $event)
      }
    }
  }, [(_vm.itemGroup) ? _vm._l((_vm.items), function(item, indexItem) {
    return _c('el-option-group', {
      key: indexItem,
      attrs: {
        "label": _vm.getLabel(item),
        "disabled": _vm.disabled
      }
    }, _vm._l((item.options), function(subItem, indexSubItem) {
      return _c('el-option', {
        key: indexItem + indexSubItem,
        attrs: {
          "label": _vm.getLabel(subItem),
          "value": _vm.getValue(subItem),
          "disabled": _vm.disabled
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.getHtml(subItem))
        }
      })])
    }), 1)
  }) : _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": _vm.getLabel(item),
        "value": _vm.getValue(item)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(item))
      }
    })])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-818535aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputSelect.vue
// module id = 1524
// module chunks = 45